export const getUserAdminField = (name, array) => {
  return array.find(item => item.name === name) ?? null;
};

export const updateUseAdminFields = (object, array) => {
  if (getUserAdminField(object.name, array)) {
    return array.map(item => item.name === object.name ? { ...item, value: object.value } : item);
  }

  array.push(object)
  return array;
};